import LandingFooter from '@/components/LandingFooter.tsx'
import LandingHeader from '@/components/LandingHeader.tsx'
import { languageBasedOnTimezone } from '@/utils/language.ts'
import { useEffect } from 'react'
import styles from './PolicyPage.module.scss'

export const SubprocessorsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <div className={styles.policyContainer}>
        <div className={styles.topSection}>
          <LandingHeader language={languageBasedOnTimezone()} selectLanguageEnabled={false} />
        </div>
        <div className={styles.contentsSection}>
          <div className={styles.titleContainer}>
            <h1>Tracker Boot Sub-processor List</h1>
            <div className={styles.dates}>Effective Date: April 24, 2025</div>
            <div className={styles.dates}>Last Updated: April 24, 2025</div>
            <div>
              <p>
                This document provides a list of third-party service providers (“Sub-processors”) authorized by Bekind
                Labs LLC to process Customer Personal Data in connection with the Tracker Boot service. All
                Sub-processors listed below are subject to data protection obligations that are substantially similar to
                those outlined in Bekind Labs’ Data Processing Addendum (DPA).
              </p>
            </div>
          </div>
          <div className={styles.contentsContainer}>
            <p>Authorized Sub-processors:</p>
            <h3>1. Sentry</h3>
            <ul>
              <li>Purpose: Error tracking and performance monitoring</li>
              <li>Location: United States</li>
            </ul>
            <h3> 2. Google OAuth</h3>
            <ul>
              <li>Purpose: Authentication and identity verification</li>
              <li>Location: Global (as per Google infrastructure)</li>
            </ul>
            <h3> 3. Amazon Web Services (AWS)</h3>
            <ul>
              <li>Purpose: Cloud hosting and infrastructure</li>
              <li>Location: Global (based on selected region)</li>
            </ul>
            <p>
              Bekind Labs will notify all affected Customers via email at least thirty (30) days in advance of
              authorizing any new Sub-processor to process Customer Personal Data.
            </p>
          </div>
        </div>
      </div>
      <LandingFooter />
    </>
  )
}
